/**
 * "This browser session just presented its second factor" — one signal for
 * both ways that happens: a step-up challenge answered, or a factor enrolled
 * (enrolment grants a step-up too). Raised by the two brokers when their prompt
 * resolves TRUE; read by `StaffFirebaseFactorSync` (SOC 2 R73) to carry the
 * factor into the Firebase session the Firestore and Storage rules see.
 */

type Listener = () => void;

const listeners = new Set<Listener>();

/** Subscribe; returns the unsubscribe function. */
export function onSecondFactorPresented(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Raise the signal. A listener that throws never stops the others. */
export function notifySecondFactorPresented(): void {
  for (const listener of [...listeners]) {
    try {
      listener();
    } catch {
      // A listener's failure is its own; the step-up itself succeeded.
    }
  }
}
